import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Router, useRouter } from "next/router";
import axios from "axios";
import ReactStars from "react-stars";
import config from "../../../config";
import cookie from "js-cookie";
import { parse } from "cookie";
import { getNonObtb } from "../../../api.services.js/others";
import { getIntouch } from "../../../api.services.js/others";
import { GetPlaceDetailsByUrlKey } from "../../../api.services.js/others";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Head from "next/head";
import { GetProductsOnStorePage } from "../../../api.services.js/others";
export async function getServerSideProps(context) {
  const { req } = context;
  const cookies = parse(req.headers.cookie || "");
  // const placeId = cookies.placeId;
  // const cp = cookies.cp;

  let props;
  let placeDetails = null;
  let cpDetails = null;
  let urlkey = req.url.split("/")[req.url.split("/").length - 1];

  const ressult = await GetPlaceDetailsByUrlKey({ url_key: urlkey });
  console.log(ressult.data.getPlaceDetailsByUrlKey);
  let type = ressult.data?.getPlaceDetailsByUrlKey.type || "";
  const placeId =
    cookies.placeId || ressult.data.getPlaceDetailsByUrlKey.gmaps_place_id;
  const cp = cookies.cp || ressult.data.getPlaceDetailsByUrlKey.cp_code;

  try {
    if (placeId) {
      const GOOGLE_API_KEY = "AIzaSyAx8Ha5x1zD9F3YQWMXtwSRJ68okVTeSEA";
      const url = `https://maps.googleapis.com/maps/api/place/details/json?key=${GOOGLE_API_KEY}&placeid=${placeId}`;

      const response = await fetch(url);
      const data = await response.json();

      if (response.ok && data.status === "OK") {
        placeDetails = data;
      } else {
        console.error("Error fetching Google place details:", data);
      }
    } else if (cp) {
      const response = await getNonObtb({ cpcode: cp });
      const data = await response;

      if (response.networkStatus == 7) {
        cpDetails = data;
      } else {
        console.error("Error fetching getNonObtb details:", data);
      }
    }
  } catch (error) {
    console.error("Server error:", error);
  }

  // // in case type is not set in the response
  // if (type === "") {
  //   if (placeDetails) type = "obtb";
  //   else if (cpDetails) type = "non_obtb";
  // }

  props = { placeDetails, cpDetails, isNonObtb: type === "non_obtb" };

  // if (type == "non_obtb" && placeId && placeDetails) {
  //   props = { placeDetails: {}, cpDetails: placeDetails };
  // }
  // console.log(props, placeId, cp);
  return { props };
}

function StoreId({ placeDetails, cpDetails, isNonObtb }) {
  let router = useRouter();
  const [isCanonicalNeeded, setIsCanonicalNeeded] = useState(false);
  const [timeDropDown, setTimeDropDown] = useState(false);
  const { storeId } = router.query; //storeId here is google_place_id
  const [storeDetails, setStoreDetails] = useState(placeDetails?.result);
  const [isOpenNow, setIsOpenNow] = useState(false);
  const [closingTime, setClosingTime] = useState("");
  const [weeklySchedule, setWeeklySchedule] = useState([]);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [gmapId, setGmapId] = useState(placeDetails?.result?.place_id);
  const [cpCode, setCpCode] = useState(
    cpDetails?.data?.getNonObtbsByCpCode?.no
      ? cpDetails?.data?.getNonObtbsByCpCode?.no
      : ""
  );
  const [storeCity, setStoreCity] = useState(
    placeDetails?.result?.address_components?.find((s) =>
      s.types.includes("administrative_area_level_3")
    )?.long_name || ""
  );

  const [storeState, setStoreState] = useState(
    placeDetails?.result?.address_components?.find((s) =>
      s.types.includes("administrative_area_level_1")
    )?.long_name || ""
  );
  const [businessHours, setBusinessHours] = useState(
    placeDetails?.result?.opening_hours?.weekday_text
  );
  const [nonObtStorebDetail, setNonObtbStoreDetail] = useState(
    cpDetails?.data?.getNonObtbsByCpCode
  );
  const [isOpen, setIsOpen] = useState(false);
  const [getInTouch, setGetInTouch] = useState(false);
  const [displayInstaReel, setDisplayInstaReel] = useState(false);
  const [reelSrc, setReelSrc] = useState("");
  const [touch, setTouch] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    error: "",
    loading: false,
  });
  const videoLinks = [
    {
      key: "bath-selection-and-tiles",
      src: "https://www.instagram.com/reel/DE9TcU9y_mA/embed/",
    },
  ];
  useEffect(() => {
    if (!router.isReady) return; // Ensure router is ready before accessing asPath

    let endpoint = router.asPath.split("/").pop(); // Get last segment of URL
    let arr = videoLinks.filter((i) => i.key === endpoint);

    if (arr.length > 0) {
      setDisplayInstaReel(true);
      setReelSrc(arr[0].src);
    }
  }, [router.isReady, router.asPath]); // Dependency added to trigger when route changes
  useEffect(() => {
    const now = new Date();
    const indiaTime = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );
    const hours = indiaTime.getHours(); // Get hours in IST

    setIsOpen(hours < 18); // Open if before 6 PM IST
    getRelatedBlogs();
  }, []);

  useEffect(() => {
    const now = new Date();
    const currentDay = now.getDay(); // 0 for Sunday, 1 for Monday, etc.
    const currentTime = now.getHours() * 100 + now.getMinutes(); // e.g., 1330 for 1:30 PM

    const todaySchedule = storeDetails?.opening_hours?.periods?.find(
      (period) => period.open.day === currentDay
    );

    if (todaySchedule) {
      const openingTime = parseInt(todaySchedule.open.time, 10);
      const closingTime = parseInt(todaySchedule.close.time, 10);

      if (currentTime >= openingTime && currentTime < closingTime) {
        setIsOpenNow(true);
        setClosingTime(formatTime(todaySchedule.close.time));
      } else {
        setIsOpenNow(false);
      }
    }

    const schedule = storeDetails?.opening_hours?.periods?.map((period) => ({
      day: getDayName(period.open.day),
      open: formatTime(period.open.time),
      close: formatTime(period.close.time),
    }));

    setWeeklySchedule(schedule);
  }, [router.query]);

  useEffect(() => {
    // Set canonical tag only if storeId and cpCode are missing
    if (!storeId && !cpCode) {
      setIsCanonicalNeeded(true);
    }
  }, [storeId, cpCode]);
  const submitGetInTouch = async () => {
    const namee = touch.name;
    const no = touch.number;
    const pin = touch.pincode;

    if (!namee || !no) {
      setTouch({
        ...touch,
        error: "All fields are required",
      });
    } else if (pin && String(pin).length != 6) {
      setTouch({
        ...touch,
        error: "Invalid Pincode",
      });
    } else {
      setTouch({
        ...touch,
        error: "",
        loading: true,
      });
      let response = await getIntouch({
        name: namee,
        phone: no,
        pincode: pin,
      });
      if (response?.message) {
        localStorage.setItem("leadfilled", true);
        swal(response?.message);
        setTouch({
          ...touch,
          error: "",
          loading: false,
        });
      } else {
        swal(response.data.get_in_touch.msg);
        setGetInTouch(false);
        setTouch({
          name: "",
          number: "",
          error: "",
          loading: false,
        });
      }
    }
  };

  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    // try{

    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=tiles`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };
  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleTimeDropDown = async () => {
    timeDropDown == true ? setTimeDropDown(false) : setTimeDropDown(true);
  };

  const formatTime = (time) => {
    const hour = parseInt(time.substring(0, 2), 10);
    const minute = time.substring(2);
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const getDayName = (dayIndex) => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return days[dayIndex];
  };

  const redirectToGoogleMaps = (lat, lng) => {
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank");
  };

  const Responsive = () => {
    const settings = {
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      autoplay: true,
      centerMode: false,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false,
      centerPadding: "0px",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 991,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 680,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 420,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 3,
          },
        },
      ],
    };

    return (
      <div className="menu-slider store-locator-page">
        <div className="container">
          <link
            rel="stylesheet"
            type="text/css"
            charSet="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          />
          <Slider {...settings} className="category-menu">
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/floor-tiles">
                  <img src="/FLOOR TILES.jpg" alt="Image" />
                </a>
                <p>Floor Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/wall-tiles">
                  <img src="/WALL TILES.jpg" loading="lazy" alt="Image" />
                </a>
                <p>Wall Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/bathroom-tiles">
                  <img src="/BATHROOM TILES.jpg" loading="lazy" alt="Image" />
                </a>
                <p>Bathroom Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/kitchen-tiles">
                  <img src="/KITCHEN TILES.jpg" alt="Image" />
                </a>
                <p>Kitchen Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/living-room-tiles">
                  <img src="/new-room-tiles.webp" alt="Image" />
                </a>
                <p>Room Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/marble-tiles">
                  <img src="/MARBLE TILES.jpg" alt="Image" />
                </a>
                <p>Marble Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/wooden-tiles">
                  <img src="/WOODEN TILES.jpg" alt="Image" />
                </a>
                <p>Wooden Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/vitrified-tiles">
                  <img src="/VITRIFIED TILE.jpg" alt="Image" />
                </a>
                <p>Vitrified Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/ceramic-tiles">
                  <img src="/CERAMIC TILES.jpg" alt="Image" />
                </a>
                <p>Ceramic Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/cool-tiles">
                  <img src="/COOL TILES.jpg" alt="Image" />
                </a>
                <p>Cool Tiles</p>
              </div>
            </div>
            <div>
              <div className="menu-item">
                <a href="https://www.orientbell.com/tiles/large-tiles-tiles">
                  <img src="/LARGE TILES.jpg" alt="Image" />
                </a>
                <p>Large Tiles</p>
              </div>
            </div>
          </Slider>

          {/* <div>
          {displayInstaReel && (
        <iframe
          src={reelSrc}
          width="400"
          height="500"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
          </div> */}
        </div>
      </div>
    );
  };

  return (
    <>
      <Head>
        <meta
          name="description"
          content={`Visit ${
            !nonObtStorebDetail
              ? `${storeDetails?.name} in ${storeCity}`
              : `${nonObtStorebDetail.name} in ${nonObtStorebDetail?.city}`
          }. Extensive range of wall & floor tiles. Get expert advice and see the range of Orientbell Tiles. Visit our showroom today!`}
        />

        <title>
          {!nonObtStorebDetail
            ? `${storeDetails?.name} - ${storeCity}, ${storeState}`
            : `${nonObtStorebDetail.name} - ${nonObtStorebDetail?.city}, ${nonObtStorebDetail?.state_desc}`}
          | Quality Floor & Wall Tiles
        </title>

        <meta
          name="title"
          content={`${
            !nonObtStorebDetail
              ? `${storeDetails?.name} - ${storeCity}, ${storeState}`
              : `${nonObtStorebDetail.name} - ${nonObtStorebDetail?.city}, ${nonObtStorebDetail?.state_desc}`
          } | Quality Floor & Wall Tiles`}
        />
        {/* {isCanonicalNeeded && (
          <>
            <link rel="canonical" href="https://www.orientbell.com/store-locator/tiles-dealer" />
            <link rel="canonical" href="https://www.orientbell.com/store-locator/" />
          </>
        )} */}
      </Head>

      <div className="obl-store-page">
        <div className="obl-store-intro-section">
          <div className="container">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="/store-locator">
                Store Locator
              </Breadcrumb.Item>
              <Breadcrumb.Item
                href={`/store-locator/tiles-dealer/${(!nonObtStorebDetail
                  ? storeDetails?.name
                  : nonObtStorebDetail?.name
                )
                  ?.toLowerCase()
                  .replace(/\s+/g, "-")}`}
              >
                {!nonObtStorebDetail
                  ? storeDetails?.name
                  : nonObtStorebDetail?.name}
              </Breadcrumb.Item>
            </Breadcrumb>
            <div className="obl-store-intro-row">
              <div className="obl-store-intro-left">
                {!nonObtStorebDetail ? (
                  <>
                    {isNonObtb ? (
                      // non obtb with placeId
                      <h1>
                        Orientbell Tiles Dealer - {storeDetails?.name}{" "}
                        <div style={{ color: "red" }}>
                          {" "}
                          {storeDetails?.business_status ===
                          "CLOSED_PERMANENTLY"
                            ? `(CLOSED PERMANENTLY)`
                            : ""}
                        </div>
                      </h1>
                    ) : (
                      // obtb
                      <h1>
                        {storeDetails?.name}{" "}
                        <div style={{ color: "red" }}>
                          {" "}
                          {storeDetails?.business_status ===
                          "CLOSED_PERMANENTLY"
                            ? `(CLOSED PERMANENTLY)`
                            : ""}
                        </div>
                      </h1>
                    )}
                  </>
                ) : (
                  <h1>
                    Orientbell Tiles Dealer - {nonObtStorebDetail.name}{" "}
                    {storeDetails?.business_status === "CLOSED_PERMANENTLY"
                      ? `(CLOSED PERMANENTLY)`
                      : ""}{" "}
                  </h1>
                )}
                <ul className="info-group">
                  <li>
                    <div className="info-icon">
                      <img src="/business-i.png" />
                    </div>
                    {!nonObtStorebDetail ? (
                      <div className="info-text">
                        {isNonObtb
                          ? // non obtb with placeId
                            storeDetails?.name
                          : // obtb
                            storeDetails?.name.split("-")[1]}
                      </div>
                    ) : (
                      <div className="info-text">
                        {" "}
                        {/* non obtb with cpCode */}
                        {nonObtStorebDetail?.name}
                      </div>
                    )}
                  </li>
                  <li>
                    <div className="info-icon">
                      <img src="/ss-i.png" />
                    </div>
                    {!nonObtStorebDetail ? (
                      <div className="info-text">
                        {storeDetails?.formatted_address}
                      </div>
                    ) : (
                      <div className="info-text">
                        {
                          <div className="info-text">
                            {nonObtStorebDetail?.address}
                          </div>
                        }
                      </div>
                    )}
                  </li>
                  <li>
                    <div className="info-icon">
                      <img src="/s-phone-i.png" />
                    </div>
                    <div className="info-text">
                      {!nonObtStorebDetail ? (
                        <a href={`tel:${storeDetails?.formatted_phone_number}`}>
                          {storeDetails?.formatted_phone_number}
                        </a>
                      ) : (
                        <a href={`tel:${nonObtStorebDetail?.phone_no}`}>
                          {nonObtStorebDetail?.phone_no}
                        </a>
                      )}
                    </div>
                  </li>
                  {!nonObtStorebDetail ? (
                    <li
                      className={
                        timeDropDown ? "store-clock active" : "store-clock"
                      }
                      onClick={handleTimeDropDown}
                    >
                      <div className="info-icon">
                        <img src="/s-clock-i.png" />
                      </div>
                      <div className="info-text">
                        {isOpenNow ? (
                          <>
                            <span className="arrow-btn">
                              Open until {closingTime}
                            </span>
                            <button>Open Now</button>
                          </>
                        ) : (
                          <button>Closed Now</button>
                        )}

                        <ul className="dropdown-list">
                          {weeklySchedule?.map((schedule, index) => (
                            <li key={index}>
                              <span className="first-text">{schedule.day}</span>
                              <span className="info-text">
                                {schedule.open} - {schedule.close}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  ) : (
                    <li
                      className={
                        timeDropDown ? "store-clock active" : "store-clock"
                      }
                      onClick={handleTimeDropDown}
                    >
                      <div className="info-icon">
                        <img src="/s-clock-i.png" />
                      </div>
                      <div className="info-text">
                        {isOpen ? (
                          <>
                            <span className="arrow-btn">
                              Open until 6:00 PM
                            </span>
                            <button>Open Now</button>
                          </>
                        ) : (
                          <span className="arrow-btn closed">Closed</span>
                        )}
                        <ul class="dropdown-list">
                          <li>
                            {" "}
                            <span class="first-text">Monday</span>{" "}
                            <span class="info-text">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li>
                            {" "}
                            <span class="first-text">Tuesday</span>{" "}
                            <span class="info-text">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li>
                            {" "}
                            <span class="first-text">Wednesday</span>{" "}
                            <span class="info-text">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li>
                            {" "}
                            <span class="first-text">Thursday</span>{" "}
                            <span class="info-text">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li>
                            {" "}
                            <span class="first-text">Friday</span>{" "}
                            <span class="info-text">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li>
                            {" "}
                            <span class="first-text">Saturday</span>{" "}
                            <span class="info-text">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                        </ul>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
              <div className="obl-store-intro-right">
                <a href="#">
                  <img src="/store-loc-ban.jpg" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="store-feature-product-section">
          <div className="container">
            {!nonObtStorebDetail ? (
              <h2>
                Featured Products in {storeCity}, {storeState}
              </h2>
            ) : (
              <h2>
                Featured Products in {nonObtStorebDetail?.city},{" "}
                {nonObtStorebDetail?.state_desc}
              </h2>
            )}
            <div className="store-feature-product-row">
              <Slider {...settings}>
                <div className="store-pro-slid-bx">
                  <div className="store-pro-img">
                    <a href="#">
                      <img
                        src="https://images.orientbell.com/media/catalog/product/n/a/nano_ivory_1.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="store-pro-text">
                    <h4>Nano Ivory (P)</h4>
                    {/* <p>
  {!nonObtStorebDetail ? storeDetails?.name?.split('-')[1] : nonObtStorebDetail?.name}
</p> */}

                    <button
                      onClick={() => setGetInTouch(true)}
                      className="buynow-btn"
                    >
                      Know More
                    </button>
                  </div>
                </div>
                <div className="store-pro-slid-bx">
                  <div className="store-pro-img">
                    <a href="#">
                      <img
                        src="https://images.orientbell.com/media/catalog/product/o/d/odg-alberta-beige.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="store-pro-text">
                    <h4>ODG Alberta Beige</h4>
                    {/* <p>
  {!nonObtStorebDetail ? storeDetails?.name?.split('-')[1] : nonObtStorebDetail?.name}
</p> */}
                    <button
                      onClick={() => setGetInTouch(true)}
                      className="buynow-btn"
                    >
                      Know More
                    </button>
                  </div>
                </div>
                <div className="store-pro-slid-bx">
                  <div className="store-pro-img">
                    <a href="#">
                      <img
                        src="https://images.orientbell.com/media/catalog/product/o/h/ohg_line_travertine_brown_hl_odg_travertine_brown_lt_dk_300x450_mm_1.webp"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="store-pro-text">
                    <h4>ODG Travertine Brown LT</h4>
                    {/* <p>
  {!nonObtStorebDetail ? storeDetails?.name?.split('-')[1] : nonObtStorebDetail?.name}
</p> */}
                    <button
                      onClick={() => setGetInTouch(true)}
                      className="buynow-btn"
                    >
                      Know More
                    </button>{" "}
                  </div>
                </div>
                <div className="store-pro-slid-bx">
                  <div className="store-pro-img">
                    <a href="#">
                      <img
                        src="https://images.orientbell.com/media/catalog/product/o/d/odg_dakota_brown_light.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="store-pro-text">
                    <h4>ODG Dakota Brown Light</h4>
                    {/* <p>
  {!nonObtStorebDetail ? storeDetails?.name?.split('-')[1] : nonObtStorebDetail?.name}
</p> */}
                    <button
                      onClick={() => setGetInTouch(true)}
                      className="buynow-btn"
                    >
                      Know More
                    </button>{" "}
                  </div>
                </div>
                <div className="store-pro-slid-bx">
                  <div className="store-pro-img">
                    <a href="#">
                      <img
                        src="https://images.orientbell.com/media/catalog/product/c/o/cool_tile_ec_1.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="store-pro-text">
                    <h4>OPV Orient EC Cool Tiles</h4>
                    {/* <p>
  {!nonObtStorebDetail ? storeDetails?.name?.split('-')[1] : nonObtStorebDetail?.name}
</p> */}
                    <button
                      onClick={() => setGetInTouch(true)}
                      className="buynow-btn"
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
        <div className="obl-store-reviews-section">
          <div className="container">
            <div className="obl-store-about-row">
              {!nonObtStorebDetail ? (
                <h2>
                  Orientbell Tiles - Tile Store in {storeCity}, {storeState}
                </h2>
              ) : (
                <h2>
                  Orientbell Tiles - Tile Store in {nonObtStorebDetail.city},{" "}
                  {nonObtStorebDetail.state_desc}
                </h2>
              )}
              <p>
                {" "}
                Orientbell Tiles is one of India’s leading tile manufacturers
                with manufacturing plants in Sikandarabad (U.P.), Dora (Gujarat)
                &amp; Hoskote (Karnataka). Orientbell Tiles was established in
                1977 and since then it continues to be one of the trusted tile
                companies of India. The company manufacturers wall and floor
                tiles in ceramic, vitrified, double charge &amp; full-body
                categories and it’s dealer/channel partners are spread across
                pan-India. In the last couple of years, the company has evolved
                digitally with a launch of QuickLook; as an exclusive
                visualization tool now available at several of its dealers and
                tile boutiques, Trulook, Samelook, Trailook and has also
                relaunched it’s website with industry-first features and
                world-class tools.
                <br />
                The address of this dealer is Shop No 123 to 125, Samman Bazar,
                Jangpura, Bhogal, New Delhi, Delhi.{" "}
              </p>
            </div>
            <div className="obl-store-reviews-info">
              <div className="obl-store-reviews-col">
                <div className="store-card-row">
                  {!nonObtStorebDetail && (
                    <div className="card-header">
                      <h3>Ratings & Reviews</h3>
                      <div className="rating-row">
                        <ReactStars
                          count={5}
                          value={storeDetails?.rating}
                          edit={false}
                          size={30}
                          color2={"#ff5e00"}
                        />
                        <p>{storeDetails?.rating}</p>
                      </div>
                      <ul className="store-rating">
                        {storeDetails?.reviews
                          ?.slice(0, 2)
                          ?.map((review, index) => {
                            const {
                              author_name,
                              time,
                              rating,
                              text,
                              author_url,
                              profile_photo_url,
                            } = review;

                            // Convert the time to a human-readable format
                            const reviewDate = new Date(
                              time * 1000
                            ).toLocaleDateString();

                            return (
                              <li key={index}>
                                <div>
                                  <p>
                                    <strong>{author_name}</strong>
                                  </p>
                                  <p>Posted on: {reviewDate}</p>
                                  <p className="rated-row">
                                    Rated:
                                    <ReactStars
                                      count={5}
                                      value={rating}
                                      edit={false}
                                      color2={"#ff5e00"}
                                    />
                                  </p>
                                  {text && <p>Review: {text}</p>}
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                      <div className="review-btn-section-row">
                        <div className="review-action">
                          <button
                            onClick={() =>
                              window.open(
                                `https://search.google.com/local/reviews?placeid=${gmapId}`,
                                "_blank"
                              )
                            }
                          >
                            View All
                          </button>
                        </div>
                        <div className="review-action submit obl-store-actions-btn">
                          <button
                            onClick={() =>
                              window.open(
                                `https://search.google.com/local/writereview?placeid=${gmapId}`,
                                "_blank"
                              )
                            }
                          >
                            Submit a Review
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {businessHours ? (
                  <div className="store-card-row">
                    <div className="card-header">
                      <h3>Business Hours</h3>
                      <div className="BusinessHours-row">
                        {businessHours.map((hour, index) => {
                          const [day, time] = hour.split(": "); // Split the day and the time
                          const dayAbbreviation = day.slice(0, 3); // Extract the first 3 letters of the day
                          const formattedTime = time ? time.trim() : "Closed";

                          return (
                            <ul key={index} className="BusinessHours-col">
                              <li className="info-card">
                                <span className="first-text">
                                  {dayAbbreviation}
                                </span>
                                <span
                                  className={
                                    formattedTime == "Closed"
                                      ? "info-text text-danger"
                                      : "info-text"
                                  }
                                >
                                  {formattedTime}
                                </span>
                              </li>
                            </ul>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="store-card-row">
                    <div className="card-header">
                      <h3>Business Hours</h3>
                      <div class="BusinessHours-row">
                        <ul class="BusinessHours-col">
                          <li class="info-card">
                            {" "}
                            <span class="first-text">Mon</span>{" "}
                            <span class="info-text ">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li class="info-card">
                            {" "}
                            <span class="first-text">Tue</span>{" "}
                            <span class="info-text ">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li class="info-card">
                            {" "}
                            <span class="first-text">Wed</span>{" "}
                            <span class="info-text ">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li class="info-card">
                            {" "}
                            <span class="first-text">Thu</span>{" "}
                            <span class="info-text ">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                        </ul>
                        <ul class="BusinessHours-col">
                          <li class="info-card">
                            {" "}
                            <span class="first-text">Fri</span>{" "}
                            <span class="info-text ">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li class="info-card">
                            {" "}
                            <span class="first-text">Sat</span>{" "}
                            <span class="info-text ">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                          <li class="info-card">
                            {" "}
                            <span class="first-text">Sun</span>{" "}
                            <span class="info-text ">10:00 AM - 6:00 PM</span>{" "}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="obl-store-reviews-col">
                <div className="store-card-row">
                  {/* <div className='card-header'>
                  <h3>Other Dealers of Orientbell Tiles</h3>
                  {
                    !nonObtStorebDetail ?

                  <ul className="other-dealers-list">
 <li>
    Orientbell Tiles dealers in{' '}
    <a
      href={`http://localhost:3000/store-locator/${encodeURIComponent(storeState)}/${encodeURIComponent(storeCity)}`}
    >
      {storeCity}
    </a>
</li>

  <li>
    Orientbell Tiles dealers in{' '}
    <a
      href={`http://localhost:3000/store-locator/${encodeURIComponent(storeState)}`}
    >
      {storeState}
    </a>
  </li>
</ul>
:
<ul className="other-dealers-list">
<li>
  Orientbell Tiles dealers in{' '}
  <a
  href={`http://localhost:3000/store-locator/${nonObtStorebDetail.state_desc.toLowerCase().replace(/\s+/g, "-")}/${nonObtStorebDetail.city.toLowerCase().replace(/\s+/g, "-")}`}
>
  {nonObtStorebDetail.city}
</a>

</li>
<li>
  Orientbell Tiles dealers in{' '}
  <a
    href={`http://localhost:3000/store-locator/${encodeURIComponent(nonObtStorebDetail.state_desc.toLowerCase().replace(/\s+/g, "-"))}`}
  >
    {nonObtStorebDetail.state_desc}
  </a>
</li>
</ul>
                  }

                </div> */}

                  <div className="card-header">
                    <h3>Other Dealers of Orientbell Tiles</h3>
                    {!nonObtStorebDetail ? (
                      <ul className="other-dealers-list">
                        <li>
                          Orientbell Tiles dealers in{" "}
                          <a
                            href={`/store-locator/${encodeURIComponent(
                              storeState
                            )}/${encodeURIComponent(storeCity)}`}
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default navigation
                              localStorage.removeItem("cityFromSimpleSearch");
                              localStorage.setItem(
                                "stateFromAdvancedSearch",
                                storeState
                              );
                              localStorage.setItem(
                                "cityFromAdvancedSearch",
                                storeCity
                              );
                              window.location.href = `/store-locator/${encodeURIComponent(
                                storeState
                              )
                                ?.toLowerCase()
                                .replace(/\s+/g, "-")}/${encodeURIComponent(
                                storeCity
                              )
                                ?.toLowerCase()
                                .replace(/\s+/g, "-")}`;
                            }}
                          >
                            {storeCity}
                          </a>
                        </li>

                        <li>
                          Orientbell Tiles dealers in{" "}
                          <a
                            href={`/store-locator/${encodeURIComponent(
                              storeState
                            )}`}
                            onClick={(e) => {
                              e.preventDefault();
                              localStorage.setItem(
                                "stateFromAdvancedSearch",
                                storeState
                              );
                              localStorage.removeItem("cityFromAdvancedSearch");
                              localStorage.removeItem("cityFromSimpleSearch");
                              window.location.href = `/store-locator/${encodeURIComponent(
                                storeState
                              )
                                ?.toLowerCase()
                                .replace(/\s+/g, "-")}`;
                            }}
                          >
                            {storeState}
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul className="other-dealers-list">
                        <li>
                          Orientbell Tiles dealers in{" "}
                          <a
                            href={`/store-locator/${nonObtStorebDetail.state_desc
                              .toLowerCase()
                              .replace(/\s+/g, "-")}/${nonObtStorebDetail.city
                              .toLowerCase()
                              .replace(/\s+/g, "-")}`}
                            onClick={(e) => {
                              e.preventDefault();
                              localStorage.removeItem("cityFromSimpleSearch");
                              localStorage.setItem(
                                "stateFromAdvancedSearch",
                                nonObtStorebDetail.state_desc
                              );
                              localStorage.setItem(
                                "cityFromAdvancedSearch",
                                nonObtStorebDetail.city
                              );
                              window.location.href = `/store-locator/${nonObtStorebDetail.state_desc
                                .toLowerCase()
                                .replace(/\s+/g, "-")}/${nonObtStorebDetail.city
                                .toLowerCase()
                                .replace(/\s+/g, "-")}`;
                            }}
                          >
                            {nonObtStorebDetail.city}
                          </a>
                        </li>
                        <li>
                          Orientbell Tiles dealers in{" "}
                          <a
                            href={`/store-locator/${nonObtStorebDetail.state_desc
                              .toLowerCase()
                              .replace(/\s+/g, "-")}`}
                            onClick={(e) => {
                              e.preventDefault();
                              localStorage.setItem(
                                "stateFromAdvancedSearch",
                                nonObtStorebDetail.state_desc
                              );
                              localStorage.removeItem("cityFromAdvancedSearch");
                              localStorage.removeItem("cityFromSimpleSearch");
                              window.location.href = `/store-locator/${nonObtStorebDetail.state_desc
                                .toLowerCase()
                                .replace(/\s+/g, "-")}`;
                            }}
                          >
                            {nonObtStorebDetail.state_desc}
                          </a>
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
                <div className="store-card-row">
                  <div className="card-header">
                    <h3>Payment Methods</h3>
                    <ul className="store-service-list">
                      <li>Cash</li>
                      <li>Online Payment</li>
                    </ul>
                  </div>
                </div>
                {/* <div className='store-card-row'>
                <div className='card-header'>
                  <h3>Parking Options</h3>
                  <ul className='store-service-list'>
                    <li>Free parking on site</li>
                  </ul>
                </div>
              </div> */}
                {!nonObtStorebDetail && (
                  <div className="store-card-row">
                    <div className="card-header">
                      <h3>
                        Get Direction To {storeDetails?.name.split("-")[1]}
                      </h3>
                      <div className="pluscode-location">
                        <div className="pluscode-location-left">
                          <a
                            href={`https://www.google.com/search?q=<business_name>
${storeDetails?.name}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Business Profile
                          </a>

                          {/* <a href={`https://plus.codes/${storeDetails?.plus_code?.global_code}`}>
  {storeDetails?.plus_code?.global_code}
</a>
                      <a href={`https://plus.codes/${storeDetails?.plus_code?.global_code}`}>{storeDetails?.plus_code?.compound_code}</a> */}
                        </div>
                        <div
                          className="pluscode-location-right"
                          onClick={() =>
                            redirectToGoogleMaps(
                              storeDetails.geometry.location.lat,
                              storeDetails.geometry.location.lng
                            )
                          }
                        >
                          <img src="/s-direction-i.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="store-additional-content">
          <div className="container">
            <h2>Explore Our Range</h2>
          </div>
        </div>
        {Responsive()}
        <div className="additional-content-section">
          <div className="container">
            {!nonObtStorebDetail ? (
              <h2>
                Orientbell Tiles in {storeCity}, {storeState}
              </h2>
            ) : (
              <h2>
                Orientbell Tiles in {nonObtStorebDetail.city},{" "}
                {nonObtStorebDetail.state_desc}
              </h2>
            )}
            <div className="store-additional-content-wrap">
              <div className="store-additional-content-row">
                <h3>Bathroom Tiles</h3>
                <p>
                  Maintaining good hygiene and enjoying a refreshing hot shower
                  or preparing for a productive day starts with a bathroom that
                  meets your needs and reflects your personality. Orientbell
                  Tiles offers diverse{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/bathroom-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    bathroom tile
                  </a>{" "}
                  variants that cater to every style and budget. Our stylish
                  bathroom wall tiles and anti-skid bathroom floor tiles are a
                  perfect combination to provide both visual appeal and safety
                  features for your bathroom. Be it ceramic or vitrified, each
                  tile type is crafted to uplift any bathroom's look and
                  usability, creating a pleasant environment for relaxation.
                  Talking about designs, we have something for every bathroom -
                  from classic choices like wooden and marble designs for both
                  walls and floors to innovative wall designs like{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/dolphin-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    dolphin tiles
                  </a>{" "}
                  to add a playful and unique touch to your bathroom walls. Our
                  bathroom tile designs not only add aesthetic charm but also
                  ensure lasting quality. Explore bathroom tile prices in your
                  city that can both upgrade your bathroom beautifully and fit
                  every budget. Choose Orientbell Tiles for your next bathroom
                  renovation!
                </p>
              </div>
              <div className="store-additional-content-row">
                <h3>Kitchen Tiles</h3>
                <p>
                  The kitchen is the heart of the home, where wonderful dishes
                  are prepared. Every kitchen is a centre of warmth and life,
                  from family gatherings to sharing meals and stories. The key
                  to a great kitchen is ensuring its functions as well as its
                  looks. Orientbell Tiles offers countless design choices in{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/kitchen-tiles/kitchen-wall-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    kitchen wall tiles
                  </a>
                  , from sleek, elegant floral to charming{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/cup-plate-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    cup plate tiles
                  </a>{" "}
                  that add a touch of personality. Focusing on both style and
                  usability, our kitchen wall and floor tiles provide easy
                  cleaning and are long-lasting. With a selection of choices to
                  fit diverse preferences and budgets, you can find the perfect
                  tiles to suit your kitchen decor. Explore our kitchen tile
                  prices in your city to find the right option for your
                  renovation needs. Choose Orientbell Tiles for a stylish and
                  functional kitchen upgrade!
                </p>
              </div>
              <div className="store-additional-content-row">
                <h3>Living Room Tiles</h3>
                <p>
                  Any good living room would be relaxing and productive. From
                  watching TV with family to welcoming guests, the living room
                  is meant to feel comfortable and inviting. Orientbell Tiles
                  offers excellent living room tile designs, designed to upgrade
                  every living room’s visual beauty and usability. Our
                  collection features stylish wall tiles and modern floor tiles
                  for living rooms, blending style and elegance to suit any
                  design preference. If you are looking for contemporary living
                  room tiles for walls or timeless marble living room floor
                  tiles, we have a design to suit every inspiration. Our{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/living-room-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    tiles for living rooms
                  </a>{" "}
                  are easy to clean and maintain, ensuring your living room
                  looks stunning and withstands daily wear. Discover our variety
                  of living room tile designs and find the perfect match for
                  your home. Choose Orientbell Tiles for a stylish and sensible
                  living room upgrade!
                </p>
              </div>
              <div className="store-additional-content-row">
                <h3>Large Tiles</h3>
                <p>
                  Large tiles are an excellent choice for achieving seamless
                  continuity in design. Orientbell Tiles’ range includes
                  impressive sizes like 1200x1800mm tiles, 800x2400mm tiles, and
                  800x1600mm tiles, perfect for creating a sleek, modern look
                  with fewer grout lines. These{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/large-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    large tiles
                  </a>{" "}
                  can be used to elevate both walls and floors, creating an
                  uninterrupted and more spacious appearance in every space.
                  They offer robustness and ease of maintenance, making them a
                  practical option for commercial and residential spaces like
                  restaurants, hotels, living rooms, etc. Explore our range of
                  large tiles to find a suitable fit for your next project, and
                  enjoy a contemporary upgrade with Orientbell Tiles.
                </p>
              </div>
              <div className="store-additional-content-row">
                <h3>Elevation Tiles</h3>
                <p>
                  The first impression of your home is defined by its exterior.
                  This is where Orientbell Tiles’ elevation tiles can help you.
                  They are crafted to deliver stunning looks to building
                  exteriors and create engaging focal points in interiors. Our
                  tile range includes stylish{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/elevation-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    front elevation tiles
                  </a>{" "}
                  that are perfect for adding character and charm to any wall.
                  If you are looking for a unique, weatherproof elevation tile
                  design for your home’s exterior or an accent wall in your
                  living room, our versatile tile range provides both beauty and
                  durability. With diversity in designs and easy-to-care
                  finishes, you can create an impressive first impression and
                  enhance your building's exterior look. Discover our elevation
                  tile designs to find the perfect choice for a modern interior
                  or exterior look.
                </p>
              </div>
              <div className="store-additional-content-row">
                <h3>Parking Tiles</h3>
                <p>
                  Parking tiles are a perfect choice for various outdoor spaces,
                  including driveways, garden patios, and walkways.{" "}
                  <a
                    class="link"
                    href="https://www.orientbell.com/tiles/parking-tiles"
                    target="_blank"
                    rel="noopener"
                  >
                    Orientbell Tiles’s parking or paver tile
                  </a>{" "}
                  selection features robust parking tile design choices that
                  withstand heavy vehicle movements and harsh weather
                  conditions, making them perfect for parking areas, decks, and
                  pathways. With an exclusive array of tile finishes and styles,
                  you can enhance the functionality and look of your outdoor
                  spaces. Choose Orientbell Tiles for reliable and attractive
                  outdoor parking tiles.
                </p>
              </div>
            </div>
          </div>
          <section className="home-color-tile-section">
            <div className="container">
              <div className="home-color-tile">
                <h2>Inspiring Home Design Ideas Awaits! </h2>
                <p>
                  Discover unique home design ideas to elevate interiors and
                  exteriors with style, comfort and personal touch.
                </p>
              </div>
              <div className="home-color-tile-row">
                <div className="home-color-tile-col">
                  <a href="https://www.orientbell.com/design-ideas/bathroom-designs">
                    <div className="find-color-img">
                      <img
                        src="https://www.orientbell.com/media/design_page/bathroom_desings/600x360%20Pix_0019_ODH_TABLON_BROWN_HL_ODG_TABLON_BROWN_&_ODG_TABLON_BEIGE_300x450_MM.webp"
                        alt="image"
                      />
                    </div>
                    <div className="find-color-text">
                      <h4>Bathroom Design</h4>
                    </div>
                  </a>
                </div>
                <div className="home-color-tile-col">
                  <a href="https://www.orientbell.com/design-ideas/kitchen-designs">
                    <div className="find-color-img">
                      <img
                        src="https://www.orientbell.com/media/design_page/kitchen_designs/600x360_Pix_0010_DR_Decor_Moroccan_DK_600x1200_mm.webp"
                        alt="image"
                      />
                    </div>
                    <div className="find-color-text">
                      <h4>Kitchen Design </h4>
                    </div>
                  </a>
                </div>
                <div className="home-color-tile-col">
                  <a href="https://www.orientbell.com/design-ideas/living-room-designs">
                    <div className="find-color-img">
                      <img
                        src="https://www.orientbell.com/media/design_page/living_room_desings/600x360_Pix__0009_Dr_Gloss_Decor_Morrocan_Art_Blu_.webp"
                        alt="image"
                      />
                    </div>
                    <div className="find-color-text">
                      <h4>Living Room Design </h4>
                    </div>
                  </a>
                </div>
                <div className="home-color-tile-col">
                  <a href="https://www.orientbell.com/design-ideas/bedroom-designs">
                    <div className="find-color-img">
                      <img
                        src="https://www.orientbell.com/media/design_page/bedroom_designs/600x360%20Pix_0017_CARVING_METAL_BRECCIA_MARBLE.webp"
                        alt="image"
                      />
                    </div>
                    <div className="find-color-text">
                      <h4>Bedroom Design </h4>
                    </div>
                  </a>
                </div>
                <div className="home-color-tile-col lastchild-color-bx">
                  <a href="https://www.orientbell.com/design-ideas/pooja-room-designs">
                    <div className="find-color-img">
                      <img
                        src="https://www.orientbell.com/media/design_page/pooja_room_desings/600x360_Pix__0004_OHG_Rhomboid_Rhomboid_Creama_300x450mm.webp"
                        alt="image"
                      />
                    </div>
                    <div className="find-color-text">
                      <h4>Pooja Room Design </h4>
                    </div>
                  </a>
                </div>
              </div>
              <div className="shop-all-solor-btn">
                <a
                  href="https://www.orientbell.com/design-ideas"
                  className="default-btn shop-all-btn"
                >
                  View All Designs
                </a>
              </div>
            </div>
          </section>
        </div>

        {relatedBlogData?.length > 0 && (
          <div className="tile-related-blog">
            <h2 className="title">Blogs</h2>
            <div className="designpage-relatedpost-row">
              <Slider {...settings}>
                {relatedBlogData?.map((obj, index) => {
                  return (
                    <div className="related-blog-col" key={index}>
                      <div className="blog-figure">
                        <a href={obj.permalink}>
                          <img
                            src={obj.image}
                            loading="lazy"
                            alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                          />
                        </a>
                      </div>
                      <div className="blog-text">
                        <div className="listingDate">{obj.date}</div>
                        <div className="listingHead">
                          <a href={obj.permalink}>
                            <div
                              dangerouslySetInnerHTML={{ __html: obj.title }}
                            />
                          </a>
                        </div>
                        <div className="listingText">
                          <p>
                            {" "}
                            <div
                              dangerouslySetInnerHTML={{
                                __html: obj.content.slice(0, -11),
                              }}
                            />
                          </p>
                          <div className="listingButton">
                            <a href={obj.permalink}>Read More</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        )}

        <Modal
          show={getInTouch}
          className="pincode-popup-bx expert_assistance_modal"
          onHide={() => setGetInTouch(false)}
        >
          <Modal.Dialog>
            <Modal.Header closeButton>
              <Modal.Title>Get Tile Expert Assistance</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitGetInTouch();
                }}
              >
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name*"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Mobile Number*"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        number: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Pincode"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        pincode: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
                {touch.error && (
                  <p className="error text-danger">{touch.error}</p>
                )}

                <Button
                  variant="primary"
                  type="submit"
                  disabled={touch.loading}
                  style={{ width: "100%" }}
                >
                  {touch.loading ? "Submitting" : "Submit"}
                </Button>
              </Form>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button variant="primary" onClick={() => handlePinSave()}>
                Submit
              </Button>
            </Modal.Footer> */}
          </Modal.Dialog>
        </Modal>
      </div>
    </>
  );
}

export default StoreId;
